module.exports = __webpack_public_path__ + "img/step1.a23bbf28.png";